import React, { useEffect, useState } from 'react';

const InputGender = ({ label, register, errors, setValue, validation, defGender }) => {
  const [selectedGender, setSelectedGender] = useState(''); // State untuk menyimpan gender yang dipilih

  useEffect(() => {
    if(defGender !== ""){
      setSelectedGender(defGender);
      setValue(validation.name, defGender);
    }
  }, [defGender])

  const handleSelect = (gender) => {
    setSelectedGender(gender);
    setValue(validation.name, gender);
  };

  return (
    <div className="mb-4">
      <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center">
        <label className="block font-medium mb-2 md:mb-0 whitespace-nowrap">{label}</label>
        <div className="flex justify-end space-x-4 w-full">
          <button
            type="button"
            className={`w-full md:max-w-[142px] h-[48px] py-2 px-4 border rounded-md font-medium ${
              selectedGender === 'Laki-laki' ? 'bg-[#FFE7CA]' : 'bg-white'
            }`}
            onClick={() => handleSelect('Laki-laki')}>
            Laki-laki
          </button>
          <button
            type="button"
            className={`w-full md:max-w-[142px] h-[48px] py-2 px-4 border rounded-md font-medium ${
              selectedGender === 'Perempuan' ? 'bg-[#FFE7CA]' : 'bg-white'
            }`}
            onClick={() => handleSelect('Perempuan')}>
            Perempuan
          </button>
        </div>
      </div>

      <input
        type="hidden"
        value={selectedGender}
        {...register(validation.name, { required: 'Jenis kelamin harus diisi' })}
      />

      {errors[validation.name] && (
        <p className="text-red text-right mt-2">
          {errors[validation.name].message}
        </p>
      )}
    </div>
  );
};

export default InputGender;
